module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Deer-0de2ce53c8349265d3a111e8d22cbacf.svg";